import { queryOptions } from '@tanstack/react-query';
import { api } from '#proto/index.qonto.account_management';
import { client } from '#queries/utils';

function item(organizationId: string) {
  return queryOptions({
    queryKey: [deactivationQueries.all, organizationId] as const,
    queryFn: async () => {
      const response = await client(`/v3/organizations/${organizationId}/deactivation`, {
        method: 'GET',
      });
      return api.organizations.deactivations.firstparty.v3.ApiGetDeactivationResponse.fromJSON(
        response
      );
    },
  });
}

function list(locale: string) {
  return queryOptions({
    queryKey: [deactivationQueries.all, 'reasons', locale] as const,
    queryFn: async () => {
      const response = await client(`/v4/organizations/deactivation_reasons`, {
        method: 'GET',
        headers: { 'X-Qonto-Locale': locale },
      });
      return api.organizations.deactivations.firstparty.v4.ApiListDeactivationReasonsResponse.fromJSON(
        response
      );
    },
  });
}

export const deactivationQueries = {
  all: 'organization-deactivation' as const,
  lists: () => [deactivationQueries.all] as const,
  item,
  list,
};
